import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyElephantMode({ Copy }: ModeRendererProps) {
  return (
    <g>
      <rect width={794} height={1123} fill="#B0B0B0" />
      <ellipse cx={397} cy={520} rx={260} ry={180} fill="#8a8a8a" />
      <g className="mode-copy" transform="translate(48,840)" fill="#222">
        <text x={0} y={0} fontSize={18} fontWeight={700}>{Copy?.title}</text>
      </g>
    </g>
  );
}

export default VasarelyElephantMode;
